export class RecaptchaProvider implements IRecaptchaProvider {
    private readonly _siteKey: string;
    private _grecaptcha: any;
    private _timer: any;

    constructor(siteKey: string) {

        //console.log("RecaptchaSiteKey " + siteKey);

        this._siteKey = siteKey;
        this._grecaptcha = (window as any).grecaptcha;
    }


    public ScoreAction = (actionName: string): Promise<string> => {
        return new Promise<string>((resolve) => {

            if(!this._siteKey){
                resolve(null);
                return;
            }

            this.ResolveTokenWithWait(resolve, actionName, 10);

        });
    }

    private ResolveTokenWithWait = (resolve: any, actionName: string, attempt: number) => {
        //console.log("cekam na grecaptchu attempt: " + attempt);
        if (!this._grecaptcha && attempt > 0) {
            this._grecaptcha = (window as any).grecaptcha;
            this._timer = setTimeout(() => {
                if (!this._grecaptcha) {
                    this._timer = setTimeout(() => this.ResolveTokenWithWait(resolve, actionName, attempt - 1), 200);
                }
                else {
                    clearTimeout(this._timer);
                    this.ResolveToken(resolve, actionName);
                }
            }, 200);
        }
        else {
            clearTimeout(this._timer);
            this.ResolveToken(resolve, actionName);
        }
    };

    private ResolveToken = (resolve: any, actionName: string) => {
        if (this._grecaptcha) {
            this._grecaptcha?.enterprise.ready(async () => {
                const recaptchaResponse = await this._grecaptcha.enterprise.execute(this._siteKey, { action: actionName });
                //console.log("recaptcha response: " + recaptchaResponse);
                resolve(recaptchaResponse);
            });
        }
        else {
            //console.log("Neni mozne vyhodnotit score, grecaptcha je null");
            resolve(null);
        }
    }

}

export interface IRecaptchaProvider {
    ScoreAction: (actionName: string) => Promise<string>;
}